import React from 'react'

//components
import SolidSmallButton from '../components/Button/Solid/Small';
import LandingCard from '../components/Card/LandingCard';
import Navigation from '../components/Navigation/Navigation';
import StepsCard from '../components/Card/StepsCard';
import Accordion from '../components/Accordion/Accordion';
import Footer from '../components/Sections/Footer';

function Home() {
    return (
        <div>
            <div className=''>
                <div className='flex flex-row space-x-14 py-8 px-120 w-screen'>
                    <div>
                        <img src="https://ik.imagekit.io/xomvboztg/nbi-landing/ph-flag.png?updatedAt=1736401802703" alt="Philippine flag" />
                    </div>
                    <div className='text-14 font-semibold gray-500'>
                        This is for portfolio purpose. Not an official website nor a real website.
                    </div>
                </div>
                <div className='w-screen'>
                    <Navigation />
                </div>
                <div className='flex flex-row px-120 space-x-24 justify-center w-full h-80 shadow-md bg-gradient-to-r from-secondary-600 to-secondary-800 w-screen'>
                    <div className='flex items-center'>
                        <img src="https://ik.imagekit.io/xomvboztg/nbi-landing/Logo.png?updatedAt=1736412031365" style={{ width: "230px", height: "139px" }} alt="NBI logo" />
                    </div>
                    <div className='flex w-full ml-32'>
                        <div className='flex flex-col justify-center w-full'>
                            <div className='text-16 text-white font-bold'>
                                Department of Justice
                            </div>
                            <div className='text-20 text-white font-bold'>
                                National Bureau of Investigation
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-end items-end w-full'>
                        <img className='w-82 mt-24' src="https://ik.imagekit.io/xomvboztg/nbi-landing/image%2034.png?updatedAt=1737091562471" alt="" />
                    </div>
                </div>
                <div>
                    <div className='space-y-34 w-screen bg-no-repeat bg-cover' style={{ backgroundImage: "url('https://ik.imagekit.io/xomvboztg/nbi-landing/Container(1).svg?updatedAt=1736407378994", height: "456px" }}>
                        <div className='flex flex-col pt-120 px-165'>
                            <div className='text-white font-bold text-61 font-roboto-condensed'>
                                NBI CLEARANCE ONLINE
                            </div>
                            <div className='text-18 font-semibold text-white'>
                                Iwasan ang mga pila, iwasan ang mahaba at nakakapagod na proseso!<br /> Mag-apply o mag-renew ng iyong NBI Clearance online!
                            </div>
                        </div>
                        <div className='flex flex-row space-x-32 px-165'>
                            <div>
                                <LandingCard
                                    question="WALANG PANG CLEARANCE?"
                                    title="Mag-apply para sa clearance"
                                    description="Ibigay ang iyongpersonal na detalye para simulan ang proseso ng application"
                                />
                            </div>
                            <div>
                                <LandingCard
                                    question="MAY EXPIRED CLEARANCE?"
                                    title="Mag-renew ng clearance"
                                    description="Ibigay ang iyong NBI ID number para maka-kuha ng renewed clearance"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full' style={{ backgroundImage: "url('https://ik.imagekit.io/xomvboztg/nbi-landing/Gradient.svg?updatedAt=1736479300027", backgroundRepeat: 'no-repeat', }}>
                    <div className='px-165'>
                        <div className='pt-125'>
                            <div className='text-32 font-bold'>
                                Paano kumuha ng NBI Clearance online?
                            </div>
                            <div className='text-16 text-gray-600'>
                                Schedule appointments, process payments, book door-to-door delivery,<br /> verify clearance, and do a quick renewal.
                            </div>
                        </div>
                    </div>
                    <div className='space-y-16'>
                        <div className='flex flex-row space-x-8 px-165 mt-32'>
                            <div>
                                <SolidSmallButton
                                    name="New Applications"
                                    textColor="text-white"
                                    bgColor="bg-tamarillo-600" />
                            </div>
                            <div>
                                <SolidSmallButton
                                    name="Renew expired clearance"
                                    textColor="text-gray-500"
                                    bgColor="bg-gray-100" />
                            </div>
                        </div>
                        <div className='flex flex-row space-x-24 px-165'>
                            <div>
                                <StepsCard
                                    step="Step 1"
                                    title="Patunayan ang pagkakakilanlan"
                                    description="Mag-upload ng valid ID at i-validate ang iyong phone number gamit ang OTP"
                                    buttonName="Simulan"
                                />
                            </div>
                            <div>
                                <StepsCard
                                    step="Step 2"
                                    title="Ibigay ang personal na detalye"
                                    description="Kumpletuhin ang mga required na forms"
                                />
                            </div>
                            <div>
                                <StepsCard
                                    step="Step 3"
                                    title="Mag book ng appointment"
                                    description="Pumili ng petsa at oras para sa biometrics capturing sa NBI branch"
                                />
                            </div>
                            <div>
                                <StepsCard
                                    step="Step 4"
                                    title="Kunin ang clearance sa napiling NBI branch"
                                    description="Pumunta sa NBI branch sa tamang petsa at oras para mai-proceso ang clearance"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='px-165 space-y-16'>
                        <div className='pt-125'>
                            <div className='text-32 font-bold'>
                                Frequently Asked Questions
                            </div>
                            <div className='text-16 text-gray-600'>
                                Schedule appointments, process payments, book door-to-door delivery, verify clearance, and do a quick renewal.
                            </div>
                        </div>
                        <div className=' flex flex-col space-y-16'>
                            <div>
                                <Accordion
                                    title="Is the NBI Clearance new application can also be done online?"
                                    description="For new applications, the online system is only for appointment scheduling. This means that the applicant still needs to go to the NBI office on their scheduled appointment for the recording of their biometrics and for picture-taking."
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="Are there any additional requirements needed on getting an NBI Clearance online?"
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="I missed my scheduled appointment; can I reschedule using the online system?"
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="How to avail of the door-to-door delivery?"
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="How much is the payment for the delivery?"
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="How long will it take for my NBI Clearance to be delivered?"
                                />
                            </div>
                            <div>
                                <Accordion
                                    title="What is the difference between NBI Clearance and Police Clearance?"
                                />
                            </div>
                        </div>
                        <div className='flex flex-col items-center pt-125 space-y-18'>
                            <div className='text-32 font-bold'>
                                Contact Us
                            </div>
                            <div className='text-14 text-gray-600 text-center'>
                                Tumawag o magpadala ng mensahe sa amin para sa iyong mga tanong, mga alalahanin, o puna. <br /> Mahalaga sa amin ang iyong mga saloobin at handa kaming magbigay ng suporta.
                            </div>
                            <div className='flex flex-row space-x-4'>
                                <div className='text-14'>
                                    Tumawag sa
                                </div>
                                <div className='text-14 font-semibold'>
                                    09204129999 (Smart) or 09551405330 (Globe)
                                </div>
                            </div>
                            <div className='flex flex-row space-x-4'>
                                <div className='text-14'>
                                    or
                                </div>
                            </div>
                            <div>
                                <button className="flex justify-center bg-secondary-600 text-white text-12 font-semibold items-center py-8 px-12 cursor-pointer">
                                    Sagutan ang Contact Us Form
                                </button>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default Home